import { Select, SelectItem } from '../../../components/Select';
import {
  SupportCreateTicket,
  SupportTicketCategory,
} from '../../../types/commonTypes';

interface Props {
  categories: SupportTicketCategory[];
  loading: boolean;
  selectedCategory: string | null;
  updateFormField(key: keyof SupportCreateTicket, value: any): void;
}

export const TicketCategories = ({
  categories,
  loading,
  selectedCategory,
  updateFormField,
}: Props) => (
  <div className="py-4">
    <Select
      name="category"
      label="Ticket category"
      placeholder="Select a category"
      variant="contained"
      fullWidth
      required
      disabled={loading || categories.length === 0}
      value={selectedCategory ?? ''}
      onChange={(event) =>
        updateFormField('category', event.target.value || null)
      }
    >
      {categories.map((category) => (
        <SelectItem key={category.id} value={category.id}>
          {category.name}
        </SelectItem>
      ))}
    </Select>
  </div>
);
